import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import {default as Reactsel} from 'react-select';
import { ListItemGraphic} from 'rmwc/List';
import { TabBar, Tab, TabIcon, TabIconText, TabBarScroller } from 'rmwc/Tabs'
import UserUploadedResComponent from '../learning_resource_user/UserUploadedResComponent';
import UserSegregatedResource from './UserSegregatedResource';

class PartnerSubmittedModule extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
            activeTabIndex: 0,
            selectedTabIndex: 0,
            displayModules: false,
            selectedPartner: '',
            
    		data:{
                listOfPartners: []
    		}
    	}
    }

    componentDidMount() {
        let data = Object.assign({}, this.state.data)
        let fetchPartners = 'admin/module/list_of_affiliate_partner'

        return api.getResponse(this.props.user.accessToken, fetchPartners)
        .then((result) => {
            if (result.status === 'success') {
                data.listOfPartners = result.data
                this.setState({data: data})
            }
        })
    }

    onTabChange = evt => {
        this.setState({'activeTabIndex': evt.target.value, 'selectedTabIndex': evt.target.value})
    }

    handlePartnerSelect = (option) => {
        this.setState(state => {
            return {
               selectedPartner : option
            };
        });
    }

    handleResourceFetch = (e) => {
        if(this.state.activeTabIndex === 0)
         this.setState({displayModules: true, activeTabIndex: 1})
        else
         this.setState({displayModules: true, activeTabIndex: 0})
    }

    render() {
    	let mainPageContent, initialContent
        let handleResourceFetch = this.handleResourceFetch
        let pendingStatus = 'Pending'
        let approvedStatus = 'Approved'
        let rejectedStatus = 'Rejected'
        let holdStatus = 'On Hold'
        let migratedStatus = 'Migrated'

        if (this.state.displayModules === true) {
            let uniqKey = Math.Random
            mainPageContent = (
                <div>
                    <div className="mdc-layout-grid__inner"> 
                        <div className="mdc-layout-grid__cell--span-12">
                            <TabBarScroller>
                                <div>
                                    <TabBar
                                        activeTabIndex={this.state.activeTabIndex}
                                        onChange={this.onTabChange}>
                                        <Tab>Pending</Tab>
                                        <Tab>Mapping to be discussed</Tab>
                                        <Tab>Mapping Misaligned</Tab>
                                        <Tab>Mapping Accepted</Tab>
                                        <Tab>Migrated</Tab>
                                    </TabBar>
                                </div>
                            </TabBarScroller>
                            {this.state.activeTabIndex == 0 && <UserSegregatedResource key={uniqKey} status={pendingStatus} partnerId = {this.state.selectedPartner.value} resourceType={"Affiliate"}/>}
                            {this.state.activeTabIndex == 1 && <UserSegregatedResource key={uniqKey} status={holdStatus} partnerId = {this.state.selectedPartner.value} resourceType={"Affiliate"}/>}
                            {this.state.activeTabIndex == 2 && <UserSegregatedResource key={uniqKey} status={rejectedStatus} partnerId = {this.state.selectedPartner.value} resourceType={"Affiliate"}/>}
                            {this.state.activeTabIndex == 3 && <UserSegregatedResource key={uniqKey} status={approvedStatus} partnerId = {this.state.selectedPartner.value} resourceType={"Affiliate"}/>}
                            {this.state.activeTabIndex == 4 && <UserSegregatedResource key={uniqKey} status={migratedStatus} partnerId = {this.state.selectedPartner.value} resourceType={"Affiliate"}/>}
                        </div>
                    </div>
                </div>
            )
        }

        initialContent = (
            <div>
                <Grid>
                    <GridCell span = "12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="headline5">Affiliated Partner Modules</Typography>
                        </Card>
                    </GridCell>
                </Grid>
                <Grid>
                    <GridCell span = "3">
                        <Reactsel
                            name="partnerslist"
                            onChange={this.handlePartnerSelect}
                            value={this.state.selectedPartner}
                            options={this.state.data.listOfPartners}
                            placeholder="--Select a Partner--">
                        </Reactsel>
                    </GridCell>
                    <GridCell span = "3">
                        <Button raised style={{ width: '50%' }} onClick= {((e) => handleResourceFetch(e))}>Search</Button>
                    </GridCell>
                </Grid>
            </div>
        )

    	return (
    		<div>
                {initialContent}
    			{mainPageContent}
                
    		</div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerSubmittedModule);


// WEBPACK FOOTER //
// ./src/views/learning_resource_admin/PartnerSubmittedModule.jsx